export const POWER_LOSS_TORQUES = [25, 50, 75, 100];

export const POWER_LOSS_SPEEDS = [0, 25, 50, 75, 100];
